// import "./Register.style.scss"
import { useLocation, useNavigate } from 'react-router-dom';

import { DELAY, ROLES } from '../config';
import useAuth from './useAuth';

const useAuthSetState = () => {
    const { setAuth } = useAuth();
    const location = useLocation();
    let navigate = useNavigate();
    const setAuthState =({responseData})=>{
        // * responseData must be smthg like:
        // {user: &&&& (with populated expertId || clientId || backOfficeId),
        // accessToken:%%%,  }
        console.log(
            'this is response from useAuth/setAuth',
            responseData,
            'completeStep',
            responseData?.user.completeStep);
        const accessToken = responseData?.accessToken;
        // ! maybe many Roles
        const completeStep = responseData?.user.completeStep;
        const role = responseData?.user?.role;
        // const hashedPassword = responseData?.user.password;
        let UserRoleProperty ;
        if(role === ROLES.Expert) UserRoleProperty = 'expertId';
        if(role === ROLES.Client) UserRoleProperty = 'collaboratorId';
        if(role === ROLES.Esn) UserRoleProperty = 'collaboratorEsnId';
        if(role === ROLES.Admin) UserRoleProperty = 'backOfficeId';
        setAuth({
            email: responseData?.user?.email,
            roles: role,
            accessToken,
            completeStep,
            photo: responseData.user?.[UserRoleProperty]?.persoData?.photo,
            nom: responseData.user?.[UserRoleProperty]?.persoData?.nom?? '',
            prenom: responseData.user?.[UserRoleProperty]?.persoData?.prenom ?? '',
            [UserRoleProperty]: responseData.user?.[UserRoleProperty]?._id??responseData.user?.[UserRoleProperty]+'',
            // * I may need it, I needed It in the layout connected to detect if a user is admin in the 4 step, but I can't update auth .. so it wasn;t usefull
            embeddedRoles: (UserRoleProperty == 'collaboratorId' || UserRoleProperty == 'backOfficeId' || UserRoleProperty == 'collaboratorEsnId') ? responseData.user?.[UserRoleProperty]?.roles : null,
            // * no need for this since we already stored them
            userId: responseData?.user?._id,
            // email:googleOAuth2Data?.email,
            // photo: googleOAuth2Data?.picture||
        });
    };
    const RedirectRoleAndFromBased =({role})=>{
        // get where they came from
        const from = location.state?.from?.pathname || '/';
        // ! if the user was coming from the HOME
        if (from === '/') {
            //* Dynamic rederection Role based, but since we have protection,, no need
            if (role === ROLES.Client) {
                console.log('Navigating ,,,  client');
                setTimeout(() => {
                    navigate('/client');
                    //? brute forcing
                }, DELAY);
            }
            else if (role === ROLES.Expert) {
                console.log('Navigating ,,,  expert');
                setTimeout(() => {
                    navigate('/expert');
                    //? brute forcing
                }, DELAY);
            }
            else if (role === ROLES.Admin) {
                console.log('Navigating ,,,  Admin');
                setTimeout(() => {
                    navigate('/admin');
                    //? brute forcing
                }, DELAY);
            }
            else if (role === ROLES.Esn) {
                console.log('Navigating ,,,  Esn');
                setTimeout(() => {
                    navigate('/esn');
                    //? brute forcing
                }, DELAY);
            }
        }
        // ! continue to what he was searching for
        navigate(from, { replace: true });
    };

    return {setAuthState,RedirectRoleAndFromBased};
};

export default useAuthSetState;